import { EMAIL_ACTIONS } from '../actions/emailsWrongRightActions';

export const initialState = {
	items:   [],
	loading: false,
	error:   null,
};

const emailsWrongRightReducer = (state = initialState, action) => {
	switch (action.type) {

					case EMAIL_ACTIONS.FETCH_REQUEST:
						return { ...state, loading: true, error: null };
					case EMAIL_ACTIONS.FETCH_SUCCESS:
						return { ...state, loading: false, items: action.payload };
					case EMAIL_ACTIONS.FETCH_FAILURE:
						return { ...state, loading: false, error: action.payload };

					case EMAIL_ACTIONS.ADD_REQUEST:
						return { ...state, error: null };
					case EMAIL_ACTIONS.ADD_SUCCESS:
						return { ...state };
					case EMAIL_ACTIONS.ADD_FAILURE:
						return { ...state, error: action.payload };

					case EMAIL_ACTIONS.UPDATE_REQUEST:
						return { ...state, loading: true, error: null };
					case EMAIL_ACTIONS.UPDATE_SUCCESS:
						return {
							...state,
							loading: false,
							items: state.items.map((item) =>
								item.id === action.payload.id ? action.payload : item
							),
						};
					case EMAIL_ACTIONS.UPDATE_FAILURE:
						return { ...state, loading: false, error: action.payload };

					case EMAIL_ACTIONS.REMOVE_REQUEST:
						return { ...state, loading: true, error: null };
					case EMAIL_ACTIONS.REMOVE_SUCCESS:
						return {
							...state,
							loading: false,
							items: state.items.filter((item) => item.id !== action.payload),
						};
					case EMAIL_ACTIONS.REMOVE_FAILURE:
						return { ...state, loading: false, error: action.payload };

					case EMAIL_ACTIONS.CLEAR_ERROR:
						return { ...state, error: null };

					default:
						return state;
	}
};

export default emailsWrongRightReducer;